import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { FieldOrigin, LoanFieldProps } from 'config'
import { DateTime } from 'luxon'
import { visibleLoansLogic } from 'pages/LoanStructure/Logic'
import { store } from 'reducers'
import { getPrice3decimal, removeComma } from 'utils'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'

export const trackRecordValidate = (
  borrowerSeperator: BorrowerSeperator,
  isTrackRecordOverride: boolean,
  hasTrackRecord: any,
  tracks: any,
  updateStore = false,
) => {
  let success = true
  const requiredTracks = howManyTrackRecord()
  const passedTracks = howManyPassedTrackRecord()

  if (hasTrackRecord === undefined || hasTrackRecord === null) success = false
  else {
    if (passedTracks < requiredTracks) {
      success = false
    }
  }

  if (isTrackRecordOverride) success = true

  if (updateStore) {
    const { step } = store.getState()
    let application = cloneDeep(step.application)
    const menuKey = borrowerMenuKey(borrowerSeperator, 'track')
    application[menuKey] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }
  return success
}

export const howManyTrackRecord = () => {
  let rlt = 0
  const visibleFields = visibleLoansLogic()
  const { loan, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})[FieldOrigin.TrackRecord] === false) return 0

  try {
    if (visibleFields.includes('howManyExperiences')) rlt = Number(loan?.howManyExperiences)
    else if (visibleFields.includes('experience')) rlt = Number(loan.experience?.split(' ')[0])
  } catch {}
  return rlt
}

export const howManyPassedTrackRecord = () => {
  const { borrower } = store.getState()
  let sum = 0
  Object.values(BorrowerSeperator).map((boSep) => {
    let rlt = 0
    borrower[boSep]?.tracks?.map((item: any) => {
      rlt += trackStatusCheck(boSep, item) ? 1 : 0
    })
    if (borrower[boSep]?.hasTrackRecord != true) rlt = 0
    sum += rlt
  })
  return sum
}

export const trackStatusCheck = (borrowerSeperator: BorrowerSeperator, data: any, withError: boolean = false) => {
  let success = true
  let errors = []

  const { loan, loanDetail, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const pageProps = loanFieldProperties.properties

  if (
    ((loanFieldProperties as any)['visibility'] || {})[FieldOrigin.TrackRecord] === false ||
    pageProps?.[FieldOrigin.TrackRecord]?.['visibleByBorrower']?.[borrowerSeperator] === false
  ) {
    if (withError) {
      return {
        success,
        errors: [],
      }
    }
    return success
  }
  const {
    [FieldOrigin.TrackRecord]: {
      purchaseDateBeforeLoanDate: { defaultValue: purchaseDateBeforeLoanDate = true } = {},
      addressDifferentPropertyAddr: { defaultValue: addressDifferentPropertyAddr = true } = {},
      purchaseDateBeforeSoldDate: { defaultValue: purchaseDateBeforeSoldDate = true } = {},
      soldDateBeforeLoanDate: { defaultValue: soldDateBeforeLoanDate = true } = {},
      soldDateWithin30monthsLoanDate: {
        defaultValue: { enabled: soldDateWithin30monthsLoanDate = true, value: soldDateWithinMonths = 36 } = {},
      } = {},
      purchaseDateWithin24monthsSoldDate: {
        defaultValue: { enabled: purchaseDateWithin24monthsSoldDate = true, value: purchaseDateWithinMonths = 24 } = {},
      } = {},
      soldPriceLessthan75AfterRepairValue: {
        defaultValue: {
          enabled: soldPriceLessthan75AfterRepairValue = true,
          value: soldPriceLessthanPercent = 75,
        } = {},
      } = {},

      purchaseDateBeforeLoanDateYes: { defaultValue: purchaseDateBeforeLoanDateYes = true } = {},
      addressDifferentPropertyAddrYes: { defaultValue: addressDifferentPropertyAddrYes = true } = {},
      purchaseDateWithin24monthsExistingClosingDate: {
        defaultValue: {
          enabled: purchaseDateWithin24monthsExistingClosingDate = true,
          value: purchaseDateWithinMonthsYes = 24,
        } = {},
      } = {},
      purchaseDateFrom24monthsExistingClosingDate: {
        defaultValue: {
          enabled: purchaseDateFrom24monthsExistingClosingDate = true,
          value: purchaseDateFromMonthsYes = 12,
        } = {},
      } = {},
      purchasePriceLessthan75TransactionPurPrice: {
        defaultValue: {
          enabled: purchasePriceLessthan75TransactionPurPrice = true,
          value: purchasePriceLessthanYes = 75,
        } = {},
      } = {},
    } = {},
  } = loanFieldProperties

  const { loanProcessDate, closingDate: estimatedClosingDate } = loanDetail
  const { subjectPropertyAddress, propertyPurchasePrice } = loan
  const visibleFields = visibleLoansLogic()

  errors.push(`Loan Date: ${loanProcessDate}`)

  if (data.override) {
  } else {
    if (data.asRental === false) {
      if (
        purchaseDateBeforeLoanDate &&
        DateTime.fromJSDate(new Date(loanProcessDate)).startOf('day') <
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day')
      ) {
        success = false
        errors.push(`Purchase Date must be before Loan Date.`)
      }

      if (addressDifferentPropertyAddr && data.propertyAddress == subjectPropertyAddress) {
        success = false
        errors.push(`Address cannot be the same as Subject Property Address.`)
      }

      if (
        purchaseDateBeforeSoldDate &&
        DateTime.fromJSDate(new Date(data.salesDate)).startOf('day') <
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day')
      ) {
        success = false
        errors.push(`Purchase Date must be before Sold Date.`)
      }

      if (
        soldDateBeforeLoanDate &&
        DateTime.fromJSDate(new Date(loanProcessDate)).startOf('day') <
          DateTime.fromJSDate(new Date(data.salesDate)).startOf('day')
      ) {
        success = false
        errors.push(`Sold Date must be before Loan Date.`)
      }

      if (
        soldDateWithin30monthsLoanDate &&
        DateTime.fromJSDate(new Date(loanProcessDate)).startOf('day') >
          DateTime.fromJSDate(new Date(data.salesDate)).startOf('day').plus({ months: soldDateWithinMonths })
      ) {
        success = false
        errors.push(`Sold Date must be within ${soldDateWithinMonths} months of Loan Date.`)
      }

      if (
        purchaseDateWithin24monthsSoldDate &&
        DateTime.fromJSDate(new Date(data.salesDate)).startOf('day') >
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day').plus({ months: purchaseDateWithinMonths })
      ) {
        success = false
        errors.push(`Purchase Date must be within ${purchaseDateWithinMonths} months of Sold Date.`)
      }

      if (visibleFields.includes('afterRepairValue')) {
        if (
          soldPriceLessthan75AfterRepairValue &&
          removeComma(data.salesPrice) / removeComma(loan.afterRepairValue) < soldPriceLessthanPercent / 100
        ) {
          success = false
          errors.push(`Sold Price, cannot be less than ${soldPriceLessthanPercent}% of After Repair Value.`)
          errors.push(`After Repair Value: $${getPrice3decimal(loan.afterRepairValue)}`)
        }
      }
    } else {
      if (
        purchaseDateBeforeLoanDateYes &&
        DateTime.fromJSDate(new Date(loanProcessDate)).startOf('day') <
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day')
      ) {
        success = false
        errors.push(`Purchase Date must be before Loan Date.`)
      }

      if (addressDifferentPropertyAddrYes && data.propertyAddress === subjectPropertyAddress) {
        success = false
        errors.push(`Address cannot be the same as Subject Property Address.`)
      }

      if (
        purchaseDateWithin24monthsExistingClosingDate &&
        DateTime.fromJSDate(new Date(estimatedClosingDate)).startOf('day') >
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day').plus({ months: purchaseDateWithinMonthsYes })
      ) {
        success = false
        errors.push(`Purchase Date must be within ${purchaseDateWithinMonthsYes} months of existing closing date.`)
      }

      if (
        purchaseDateFrom24monthsExistingClosingDate &&
        DateTime.fromJSDate(new Date(estimatedClosingDate)).startOf('day') <
          DateTime.fromJSDate(new Date(data.purchaseDate)).startOf('day').plus({ months: purchaseDateFromMonthsYes })
      ) {
        success = false
        errors.push(`Purchase Date must be at least ${purchaseDateFromMonthsYes} months from existing closing date.`)
      }

      if (visibleFields.includes('afterRepairValue')) {
        if (
          purchasePriceLessthan75TransactionPurPrice &&
          removeComma(data.purchasePrice) / removeComma(propertyPurchasePrice) < purchasePriceLessthanYes / 100
        ) {
          success = false
          errors.push(`Purchase Price must be within ${purchasePriceLessthanYes}% of transaction Purchase Price.`)
          errors.push(`Transaction Purchase Price: $${getPrice3decimal(propertyPurchasePrice)}`)
        }
      }
    }
  }
  if (withError) {
    return {
      success,
      errors,
    }
  }
  return success
}
